import React, { Fragment, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { EditData } from "./Components/Services";
import { useNavigate, useParams } from "react-router-dom";
import { Get } from "../../../../Request";
import Loading from "../../../Common/Components/Loading";

function Edit() {
  const initialState = {
    loading: false,
    need: true,
  };
  const { slug } = useParams();
  const [data, setData] = useState({});
  const [state, setstate] = useState(initialState);
  const navigate = useNavigate();

  const getSingle = async slug => {
    setstate({ need: true });
    await Get({
      url: "/blog/showbyslug",
      data: {
        slug,
      },
    }).then(data => {
      setData(data.data);
      setstate({ need: false });
    });
  };
  useEffect(() => {
    getSingle(slug);
  }, []);
  const Handler = data => {
    setstate({ loading: true });
    if (data.tags) {
      data = { ...data, tag_id: data.tags.map(tag => tag.value) };
    }
    EditData(data).then(() => {
      setstate({
        loading: false,
      });
    });
    navigate(-1);
  };

  if (data.need) {
    return <Loading />;
  }
  let input = [
    {
      label: "عنوان مقاله",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "title",
    },
    {
      label: "تگ های مقاله",
      size: "col-md-3",
      classNames: "mt-2 js-select2",
      placeholder: "",
      name: "tags",
      input: "selectTable",
      multiple: true,
      nested: "tags",
    },
    {
      label: "انتخاب دسته بندی",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "category_id",
      input: "select",
      nested: "blogcategory",
    },
    {
      label: "توضیحات",
      size: "col-md-12",
      classNames: "mt-2",
      name: "description",
      input: "textarea",
    },
    {
      label: "متن مقاله ",
      size: "col-md-12",
      classNames: "mt-2",
      name: "content",
      input: "ckeditor",
    },
    {
      label: "کلمات کلیدی سئو",
      size: "col-md-4",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoKeyword",
      input: "textarea",
    },
    {
      label: "توضیحات کلیدی سئو",
      size: "col-12",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoDescription",
      input: "textarea",
    },
    {
      label: "تصویر مقاله",
      size: "col-12",
      classNames: "mt-2",
      placeholder: "",
      name: "image",
      input: "file",
      accept: "image/png, image/jpeg",
      alt: true,
    },
  ];
  const middleware = data => {
    if (data && data.tags) {
      return {
        ...data,
        tags: data.tags.map(({ id: value, name: label }) => ({
          value,
          label,
        })),
      };
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ویرایش مقاله </title>
      </Helmet>

      <CommonFrom
        form={input}
        loading={state.loading}
        header={`ویرایش مقاله `}
        textbtn="لیست مقالات"
        linkbtn="/Admin/blog/List"
        btnName="ثبت ویرایش"
        submit={Handler}
        value={middleware(data)}
        initialeState={{ blog_id: data.id }}
        nested={["tags", "blogcategory"]}
        edit={true}
      />
    </Fragment>
  );
}

export default Edit;
